import { FC, ReactNode } from "react";

import { BotAvatar } from "./BotAvatar";
import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly statusLabel?: ReactNode;
  readonly showAvatar?: boolean;
}

/**
 * Animated 3-dot indicator shown while an assistant reply is in flight, optionally followed by a
 * label naming the step the agent is currently working on. The caller hides the avatar when the
 * indicator already sits under an assistant turn, which carries the avatar itself.
 */
export const BusyIndicator: FC<Props> = ({ styles, statusLabel, showAvatar = true }) => (
  <div className={styles.BusyIndicator}>
    {!!showAvatar && <BotAvatar styles={styles} />}
    {/* the live region is the always-present activity row, not the label itself: a region inserted
        with its text already in place is not announced by most screen readers. */}
    <div className={styles.BusyIndicatorActivity} aria-live="polite">
      <div className={styles.BusyIndicatorDots} role="status" aria-label="Thinking">
        <svg
          className={styles.BusyIndicatorDotsVisual}
          width="26"
          height="20"
          viewBox="0 0 26 20"
          fill="none"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="3" cy="10" r="3" />
          <circle cx="13" cy="10" r="3" />
          <circle cx="23" cy="10" r="3" />
        </svg>
      </div>
      {!!statusLabel && (
        <span className={styles.BusyIndicatorStatusLabel} data-testid="busy-status-label">
          {statusLabel}
        </span>
      )}
    </div>
  </div>
);
